const ProjectPreview = ({ selectedProject }) => {
  if (!selectedProject) return null;

  const { html, css, js, title } = selectedProject;
  const combinedCode = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${title}</title>
      <style>${css}</style>
    </head>
    <body>
      ${html}
      <script>${js}</script>
    </body>
    </html>
  `;

  return (
    <div className="project-preview">
      <iframe
        srcDoc={combinedCode}
        title={title}
        className="project-iframe"
        sandbox="allow-scripts"
      />
    </div>
  );
};

export default ProjectPreview;
